import React, { useState } from 'react';
import { Button } from 'antd';

import { checkIsCompanyOwner } from 'utils/userRolesUtils';
import PrimaryContactCard from './PrimaryContactCard';
import BasePageCard from 'components/wrappers/BasePageCard';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import { getPrimaryContactInfo } from 'redux/reducers/accountSlice';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { userSelector } from 'redux/selectors/authenticationSelectors';
import EditPrimaryContactInfoModal from './EditPrimaryContactInfoModal';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from './PrimaryContactInfo.module.less';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function PrimaryContactInfo(props: Props) {
  const { corporateInfo } = props;
  const user = useAppSelector(userSelector);
  const isCompanyOwner = checkIsCompanyOwner(user);
  const dispatch = useAppDispatch();
  const [primaryContactInfo, setPrimaryContactInfo] = useState(
    corporateInfo?.primaryContacts,
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const loadPrimaryContactInfo = async () => {
    const result = await dispatch(getPrimaryContactInfo());

    if (getPrimaryContactInfo.fulfilled.match(result)) {
      setPrimaryContactInfo(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {isModalVisible && (
        <EditPrimaryContactInfoModal
          onClose={handleCloseModal}
          onEdit={loadPrimaryContactInfo}
          primaryContactInfo={primaryContactInfo}
        />
      )}

      <BasePageCard
        title="Primary contact information"
        className="stretch-card"
        icons={<span className="icon icon-contacts"></span>}
        subTitle={
          isCompanyOwner &&
          !!primaryContactInfo?.length && (
            <Button
              onClick={handleOpenModal}
              className="with-icon mobile-icon-only"
              size="large"
              icon={<span className="icon icon-edit" />}
              data-id="openPrimaryContactInfoModal"
            >
              Edit
            </Button>
          )
        }
      >
        <div className="scroll-box">
          {!primaryContactInfo?.length && isCompanyOwner && (
            <div className="content-wrapper">
              <BaseSectionMessage
                type="info"
                title="Info"
                message={
                  <div className={styles.message}>
                    <span>
                      Please add Primary contact in order to select them in a
                      new assignment.
                    </span>
                    <Button
                      className={styles.button}
                      onClick={handleOpenModal}
                      type="link"
                    >
                      Fill in now.
                    </Button>
                  </div>
                }
              />
            </div>
          )}

          {!!primaryContactInfo?.length && (
            <>
              {primaryContactInfo.map((primaryContact, index) => (
                <PrimaryContactCard
                  key={index}
                  primaryContact={primaryContact}
                />
              ))}
            </>
          )}
        </div>
      </BasePageCard>
    </>
  );
}
